// Modal wrapper for ContractorMappingTable - opened from the coordination
// landing / schedule page ("Map contractors").
import React from "react";
import { Modal } from "antd";
import ContractorMappingTable from "./ContractorMappingTable";

export default function ContractorMappingModal({ open, onClose, projectId, canEdit = true, onChanged }) {
  return (
    <Modal open={open} onCancel={onClose} footer={null} width={1100} destroyOnClose title="Map contractors (labels from imported documents)">
      <ContractorMappingTable projectId={projectId} canEdit={canEdit} onChanged={onChanged} />
    </Modal>
  );
}
